export default ['active', 'inactive'];
